import { Component } from "react"
import PropTypes from "prop-types"

import * as DiffUtils from "./diff_utils"
import { StatusRow, BasicTableRow } from "./table_components"

class PopulatorValue extends Component {
  renderPopulatorAttributes(value, index) {
    const attributes = [
      {
        key: `populator-item-${index}-name-${value.name}`,
        name: "Name",
        value: value.name,
        fieldName: "name",
        noFeedbackAllowed: true,
      },
      {
        key: `populator-item-${index}-value-${value.value}`,
        name: "Value",
        value: value.value,
        fieldName: "value",
        noFeedbackAllowed: true,
      },
    ]
    return attributes.map(item => {
      item.diff = value.changes.find(
        diff => diff.data && diff.data.property === item.fieldName
      )
      return <BasicTableRow {...item} />
    })
  }

  render() {
    const { changes, diffStyle, parent, collection } = this.props
    let values = this.props.values || []
    // Assume filters worked and only a single field's populator changes remain
    const pattern = [
      parent,
      { __anything: true },
      collection,
      { __anything: true },
      "populator_values",
    ]

    if (diffStyle !== "none") {
      const valuesDeleted = DiffUtils.collectionDeletedItems(
        changes,
        this.props.originalChannel,
        pattern
      )
      values = values.concat(valuesDeleted)
    }
    const populatorValues = DiffUtils.setupCollectionForRender(
      changes,
      values,
      pattern
    )
    return (
      <>
        {populatorValues.map((item, index) => (
          <table
            key={`populator-item-${index}-value-${item.value}`}
            className="subtable"
          >
            <tbody>
              {this.props.diffStyle !== "none" && (
                <StatusRow status={item.type} />
              )}
              {this.renderPopulatorAttributes(item, index)}
            </tbody>
          </table>
        ))}
      </>
    )
  }
}

PopulatorValue.propTypes = {
  diffStyle: PropTypes.string.isRequired,
  originalChannel: PropTypes.object,
  values: PropTypes.array.isRequired,
  changes: PropTypes.array.isRequired,
  parent: PropTypes.string.isRequired,
  collection: PropTypes.string.isRequired,
}

export default PopulatorValue
